import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { ObraAreaChecklistDropDown } from "../../../../domain/models/obra_area_checklist_dropdown";
import { ObraChecklistServicoDropDown } from "../../../../domain/models/obra_checklist_servico_dropdown";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ExcluirObraAreaServicosForm, ExcluirObraAreaServicosSchema } from "../../../schemas/Obras_cadastroarea/excluir_obra_area_servicos";
import { useCallback, useEffect, useMemo } from "react";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

import FormContainer from "../../../../../../common/components/form_container";

/**
 * ExcluirChecklistAreaModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  areas: ObraAreaChecklistDropDown[],
  checklists: ObraChecklistServicoDropDown[],
  onChecklistChange: (checklists: number[] | null) => void;
  onClose: () => void;
  onSubmit: (form: ExcluirObraAreaServicosForm) => void;
};

export const ExcluirChecklistAreaModal = ({
  open,
  saving,
  loading,
  areas,
  checklists,
  onChecklistChange,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ExcluirObraAreaServicosForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ExcluirObraAreaServicosSchema),
  });

  const [checklistsExcluir] = hookForm.watch(['checklists']);

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [
    open,
    hookForm,
  ]);

  const selectedChecklists = useMemo(() => {
    if (!checklistsExcluir) return [];
    return checklists.filter(x => checklistsExcluir.includes(x.idChecklistServico));
  }, [
    checklists,
    checklistsExcluir,
  ]);

  const handleChecklistChange = useCallback((list: ObraChecklistServicoDropDown[] | null) => {
    if (list && list.length > 0) {
      const selectedList = list.map(x => x.idChecklistServico);
      hookForm.setValue('checklists', selectedList);
      onChecklistChange(selectedList);
    } else {
      hookForm.setValue('checklists', []);
      onChecklistChange(null);
    }
    hookForm.resetField('areas');
  }, [
    hookForm,
    onChecklistChange,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Excluir Checklist de área'
      width='50rem'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultMultiAutocomplete
            label='Checklist'
            options={checklists}
            getOptionKey={x => x.idChecklistServico}
            getOptionLabel={x => x.descricao ?? ''}
            value={selectedChecklists}
            onChange={handleChecklistChange}
            helperText={hookForm.formState.errors.checklists && hookForm.formState.errors.checklists[0]
              ? hookForm.formState.errors.checklists[0].message
              : undefined
            }
          />

          <DefaultFormMultiAutocomplete
            name='areas'
            label='Área'
            options={areas}
            getOptionKey={x => x.idObraAreaChecklist}
            getOptionLabel={x => x.descricao ?? ''}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}